export enum ApplicationDetailsType {
  entity = 'entity',
  template = 'template',
}
